import { handleActions } from 'redux-actions';

export default handleActions(
	{
		COLLECT_APARTMENT_OR_ROOM_FULFILLED: (state, action) => ({
			...state,

			roomList: action.payload.roomList,
			apartmentList: action.payload.apartmentList,
		}),

		FETCH_COLLECT_FULFILLED: (state, action) => ({
			...state,

			roomList: action.payload.roomList,
			apartmentList: action.payload.apartmentList,
		}),
	},
	{
		roomList: [],
		apartmentList: [],
	},
);



// WEBPACK FOOTER //
// ./src/reducers/collect.js